<template>
  <WechatApplymentForm />
</template>

<script>
import WechatApplymentForm from "@/views/apps/weishop/merchants/setting/wechat/applyment_form.vue";

export default {
  name: "RegionStoreWechatApplymentFormAdapter",
  components: {
    WechatApplymentForm,
  },
};
</script>
